// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component } from '@angular/core';
import { HeaderService } from '../../../header.service';
import { BehaviorSubject } from 'rxjs';
import { ALL_ORGS_ID } from '../../../../types/group';

@Component({
    selector: 'app-threat-activity-overview',
    templateUrl: './threat-activity-overview.component.html',
    styleUrls: ['./threat-activity-overview.component.scss'],
    standalone: false
})
export class ThreatActivityOverviewComponent {
  selectedOrgId$: BehaviorSubject<string> = new BehaviorSubject<string>(ALL_ORGS_ID);
  timeInterval: string = "336h"

  constructor(private headerService: HeaderService) {
    this.selectedOrgId$ = this.headerService.orgSelectedChanged
  }
}
